import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LicenseCheckPanelComponent } from '../../../../common/components/license-check-panel/license-check-panel.component';

/**
 * Standalone license lookup (EDUS-2725 support diagnostic): check ANY
 * domain's Chargify license state — including prospects that don't exist in
 * SPOG yet, which the customer-detail panel can't reach.
 */
@Component({
  selector: 'cdw-license-lookup',
  standalone: true,
  imports: [CommonModule, FormsModule, LicenseCheckPanelComponent],
  templateUrl: './license-lookup.component.html',
  styleUrl: './license-lookup.component.scss',
})
export class LicenseLookupComponent {
  @ViewChild(LicenseCheckPanelComponent)
  panel?: LicenseCheckPanelComponent;

  domain = '';

  onEnter(): void {
    this.panel?.check();
  }
}
